module.exports = __webpack_public_path__ + "media/images/kid/kid_avatar_02-0b32eca5a2eb54526820fd813a3cbb8c.png";